import React from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import {setDownloadItemActive} from "../../redux/action/download_item_actions";

class DownloadItemContainer extends React.Component {

  mounted = false;

  constructor(props){
    super(props);

    this.state = {
      isOpen: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(){
    this.setState(
      {
        isOpen: !this.state.isOpen
      },
      () => this.props.setOpen(this.props.id)
    )
  }

  componentDidMount(){
    this.mounted = true;
  }

  componentWillUnmount(){
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps){
    if( nextProps.openItemId && nextProps.openItemId !== this.props.id && this.mounted ){
      this.setState({
        isOpen: false
      });
    }
  }

  render(){

    if(!this.props.item)
      return null;

    const { obx_product_datasheet, obx_product_manual } = this.props.item.acf;

    const datasheetProps = {
      className: "download-button"
    };
    const manualProps = {
      className: "download-button"
    };

    if(!obx_product_datasheet){
      datasheetProps.className += " disabled";
    } else {
      datasheetProps.href = obx_product_datasheet.url;
      datasheetProps.target = "_blank";
      datasheetProps.rel = "noopener noreferrer";
    }

    if(!obx_product_manual){
      manualProps.className += " disabled";
    } else {
      manualProps.href = obx_product_manual.url;
      manualProps.target = "_blank";
      manualProps.rel = "noopener noreferrer";
    }

    return (
      <div>
        <Row key={this.props.key} className={"download-item"} style={{width: "100%"}}>
          <Col xs={"12"}
              onClick={this.toggle}
              className={"download-item-content"}>
           <div className={"download-item-heading"}>{ this.props.item.post_title }</div>
          </Col>
           <Col xs={"12"} className={"p-0"}>
             <div className={"download-item-buttons"}>
               <a { ...datasheetProps }>Datasheet </a>
               <a { ...manualProps }>Manual</a>
             </div>
           </Col>
        </Row>
      </div>
    );
  }
}

export const DownloadItem = connect(
  state => ({
    openItemId: state.downloadItem.id
  }),
  dispatch => ({
    setOpen: id => dispatch(setDownloadItemActive(id))
  })
)(DownloadItemContainer);



// WEBPACK FOOTER //
// ./src/components/item/DownloadItem.js